import Vue from 'vue'
import VueRouter from 'vue-router'
import { Dialog } from 'vant'

// 对常用的几个组件设置懒加载
// 一级路由，其他一级路由在下面
import layout from '@/views/layout'
import editaddress from '@/views/pay/editaddress'

// 二级路由，这部分是layout下的二级路由
import home from '@/views/layout/home'
import category from '@/views/layout/category'
import cart from '@/views/layout/cart'
import user from '@/views/layout/user'

// 导入vuex实例化的store，这样就可以在js文件中使用store了
// 一级路由
import store from '@/store/index'
// SEO 工具：统一维护标题 / 描述 / canonical
import { setSeo, setMetaRobots } from '@/utils/seo'
const search = () => import('@/views/search')
const searchlist = () => import('@/views/search/list')
const prodetail = () => import('@/views/prodetail')
const login = () => import('@/views/login')
const register = () => import('@/views/register')
const forgetpass = () => import('@/views/forgetpass')
const wechatauth = () => import('@/views/wechatauth')
const chat = () => import('@/views/chat')
const chatList = () => import('@/views/chat/list.vue')
const webview = () => import('@/views/webview/index.vue')
const pay = () => import('@/views/pay')
const payment = () => import('@/views/payment')
const address = () => import('@/views/pay/address')
const myorder = () => import('@/views/myorder')
const refund = () => import('@/views/refund')
const comment = () => import('@/views/comment')
const commentlist = () => import('@/views/commentlist')
const group = () => import('@/views/group/index.vue')
const admin = () => import('@/views/admin/index.vue')
const adminGoodsForm = () => import('@/views/admin/GoodsForm.vue')
const complaint = () => import('@/views/complaint/index.vue')
const logout = () => import('@/views/logout/index.vue')
const profile = () => import('@/views/profile/index.vue')
const shop = () => import('@/views/shop/index.vue')

Vue.use(VueRouter)

// 兼容旧版 hash 链接：访问 /#/prodetail/12 时自动改写为 /prodetail/12
// （老分享链接、老二维码、微信/支付宝历史回跳不会失效；必须在实例化路由前执行）
if (typeof window !== 'undefined' && window.location.hash.indexOf('#/') === 0) {
  const legacyPath = window.location.hash.slice(1)
  const basePath = window.location.pathname.replace(/\/index\.html$/, '')
  if (basePath === '' || basePath === '/') {
    window.history.replaceState(null, document.title, legacyPath)
  }
}

const router = new VueRouter({
  // history 模式：地址栏为真实路径（/prodetail/12），利于百度等搜索引擎收录
  // 需要服务器把未知路径重写到 index.html：
  //   Nginx : try_files $uri $uri/ /index.html;
  //   Apache: 见 public/.htaccess
  mode: 'history',
  routes: [
    {
      path: '/',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: home,
          meta: { title: '欢乐购商城 - 品质好物 · 拼单更优惠', description: '欢乐购商城热销好物推荐，拼单更优惠，正品保障、极速发货。' }
        },
        {
          path: '/category',
          component: category,
          meta: { title: '全部分类', description: '按分类浏览欢乐购商城全部商品，快速找到心仪好物。' }
        },
        {
          path: '/cart',
          component: cart,
          meta: { title: '购物车' }
        },
        {
          // 聊天：各商家客服入口（原底部导航「购物车」位置）
          path: '/chats',
          component: chatList,
          meta: { title: '聊天' }
        },
        {
          path: '/user',
          component: user,
          meta: { title: '个人中心' }
        },
        // ========== 新增：搜索页面 ==========
        {
          path: '/search',
          component: search,
          meta: { title: '搜索商品' }
        },
        {
          path: '/searchlist',
          component: searchlist,
          meta: { title: '商品列表', description: '欢乐购商城商品列表，支持按销量、价格排序筛选。' }
        },
        // ========== 新增：我的订单页面 ==========
        {
          path: '/myorder',
          component: myorder,
          meta: { title: '我的订单' }
        }
        // =====================================
      ]
    },
    {
      // 动态路由传参
      path: '/prodetail/:id',
      component: prodetail
    },
    {
      // 拼单详情 / 分享链接入口（无需登录可查看，参团时再校验登录）
      path: '/group',
      component: group
    },
    {
      path: '/login',
      component: login
    },
    {
      path: '/register',
      component: register
    },
    {
      // 忘记密码：手机号短信验证码验证后重置登录密码
      path: '/forgetpass',
      component: forgetpass
    },
    {
      // 微信网页授权回调页（微信内授权后回跳到 /wechatauth?code=xxx&state=xxx）
      path: '/wechatauth',
      component: wechatauth
    },
    {
      path: '/chat',
      component: chat
    },
    {
      // 内置浏览器：商城聊天页点击外链后打开 /webview?url=xxx
      // 顶部与底部都提供「返回商城」出口，页面被目标网站拒绝嵌入时可跳系统浏览器
      path: '/webview',
      component: webview,
      meta: { title: '网页浏览' }
    },
    {
      // 店铺主页：点击客服头像 / 店铺头像进入；「查看商家资质」需安全验证通过后可见
      path: '/shop/:id',
      component: shop,
      meta: { title: '店铺主页' }
    },
    {
      path: '/pay',
      component: pay
    },
    {
      path: '/payment',
      component: payment
    },
    {
      path: '/address',
      component: address
    },
    {
      path: '/editaddress',
      component: editaddress
    },
    {
      path: '/admin',
      component: admin
    },
    {
      // 商品新增 / 编辑（独立页面，?id=xxx 表示编辑）
      path: '/admin/goods-form',
      component: adminGoodsForm
    },
    {
      path: '/complaint',
      component: complaint
    },
    {
      path: '/logout',
      component: logout
    },
    {
      // 个人资料：修改头像 / 昵称 / 绑定手机号
      path: '/profile',
      component: profile
    },
    {
      path: '/refund',
      component: refund
    },
    {
      path: '/comment',
      component: comment
    },
    {
      path: '/commentlist',
      component: commentlist
    }
  ]
})

// 设置路由前置守卫
const authUrl = ['/pay', '/payment', '/myorder', '/address', '/chat', '/refund', '/comment', '/profile']

router.beforeEach((to, from, next) => {
  const token = store.getters.token

  // 1. 如果不需要鉴权，直接放行
  if (!authUrl.includes(to.path)) {
    next()
    return
  }

  // 2. 需要鉴权的路径
  if (!token) {
    next(`/login?redirect=${to.fullPath}`)
  } else {
    // 已登录，直接放行
    next()
  }
})

// 设置路由后置守卫：统一维护页面标题与 canonical（规范地址）
// 商品详情页等需要按数据动态设置标题的页面，会在拿到数据后覆盖这里的默认值
router.afterEach((to) => {
  const meta = to.meta || {}
  // 无需收录的后台/登录等页面加上 noindex，避免被搜索引擎抓取
  const noIndexPaths = ['/admin', '/admin/goods-form', '/login', '/register', '/forgetpass', '/pay', '/payment', '/profile', '/chat', '/cart', '/webview']
  if (noIndexPaths.includes(to.path)) {
    setMetaRobots('noindex,follow')
  } else {
    setMetaRobots('index,follow')
  }
  setSeo({
    title: meta.title,
    description: meta.description,
    path: to.fullPath
  })
})

export default router